import { Component } from '@angular/core';
import { Size, ErrorState, LabelPosition, ExtThemes, ButtonKind, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { InputModule, InputOptions, DescriptionType, TextAlign } from '@usitsdasdesign/dds-ng/input';
import { ReactiveFormsModule, FormControl } from "@angular/forms";
import { TextareaModule, TextareaOptions } from '@usitsdasdesign/dds-ng/textarea';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ActivatedRoute, Router } from '@angular/router';
import { Project } from '../core/models/project.models';
import { ProjectsService } from '../core/services/projects.service';

@Component({
  selector: 'app-project-edit',
  standalone: true,
  imports: [
    ButtonModule,
    InputModule,
    TextareaModule,
    ReactiveFormsModule,
  ],
  templateUrl: './project-edit.component.html',
  styleUrl: './project-edit.component.scss'
})
export class ProjectEditComponent {
  projectId: string;
  project: Project;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectService: ProjectsService,
  ) { }

  inputFormCtrl = new FormControl({ value: '', disabled: false });

  inputOptions: InputOptions = {
    label: 'Project name',
    labelPosition: LabelPosition.external,
    placeholder: '',
    isError: false,
    isRequired: true,
    isInverse: false,
    size: Size.md,
    description: '',
    descriptionType: DescriptionType.text,
    errorMessage: '',
    errorState: ErrorState.default,
    textAlign: TextAlign.left,
    type: 'text',
  };

  changeValue() {
  }

  onBlur() {
  }

  textareaFormCtrl = new FormControl({ value: '', disabled: false });

  textareaOptions: TextareaOptions = {
    label: 'Description',
    labelPosition: LabelPosition.external,
    placeholder: '',
    minHeight: 250,
    isRequired: false,
    isInverse: false,
    readonly: false,
    isError: true,
    errorState: ErrorState.default,
    description: '',
    errorMessage: '',
    size: Size.md
  };

  descriptionValueChanged() {
    console.log("descriptionValueChanged", this.textareaFormCtrl.value);
  }

  saveButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    isIconLeft: true,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Save',
    customClass: '',
    role: 'button'
  }

  saveButtonClick(event: Event): void {
    this.projectService.updateProject(this.projectId, { name: this.inputFormCtrl.value ?? '', description: this.textareaFormCtrl.value ?? '' })
      .subscribe((e) => {
        this.router.navigate(['project-details', this.projectId]);
      });
  }

  cancelButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primary,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: '',
    isIconLeft: true,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Cancel',
    customClass: '',
    role: 'button'
  }

  cancelClick(event: Event): void {
    this.router.navigate(['project-details', this.projectId]);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.projectId = params.get('id') ?? '';
      this.projectService.getProjectById(this.projectId).subscribe(response => {
        this.project = response;
        this.inputFormCtrl.setValue(this.project.name);
        this.textareaFormCtrl.setValue(this.project.description);
      });
    });

  }
}
